import { useState } from "react";
import { Image } from "react-bootstrap";
import "../css/image.css";

const LazyImage = ({
  src,
  alt = "",
  className = "",
  fluid = true,
  skeletonClassName = "image-skeleton",
  wrapperClassName = "d-flex justify-content-center position-relative",
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={wrapperClassName}>
      {!loaded && <div className={skeletonClassName}></div>}

      <Image
        src={src}
        alt={alt}
        className={className}
        fluid={fluid}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        style={{
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.3s ease",
        }}
      />
    </div>
  );
};

export default LazyImage;